<template>
  <div class="receiverList">
    <div class="query">
      <div style="display: flex; align-items: center; justify-self: flex-start">
        <el-form :inline="true" @submit.native.prevent>
          <el-form-item label="" style="margin-bottom: 0px">
            <el-input
              v-model="company_name"
              size="small"
              placeholder="角色名称"
            ></el-input>
          </el-form-item>
          <el-form-item class="mgl10" style="margin-bottom: 0px">
            <el-button type="primary" @click="toSearch" size="small">
              查 询
            </el-button>
            <el-button type="primary" @click="resetList" size="small">
              重 置
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-button
          type="primary"
          class="btn"
          size="small"
          @click="operateBtn('add_btn')"
          >{{ $t("label.open.add_role") }}
          <i class="el-icon-circle-plus-outline"></i>
        </el-button>
    </div>
    <div style="display: flex; align-items: center; justify-content: flex-end">
      <div class="operate-btn">
        
        <!-- <el-button
          type="danger"
          class="btn"
          size="small"
          @click="delete_batch"
          >{{ $t("label.open.delete_btn") }}</el-button
        > -->
      </div>
    </div>
    <div class="table">
      <el-table
        :data="tableData"
        ref="tableData"
        stripe
        @selection-change="handleSelectionChange"
        :height="tableHeight"
      >
        <!-- <el-table-column align="center" type="selection" width="55">
        </el-table-column> -->
        <el-table-column
          v-for="column in columns"
          :key="column"
          :prop="column"
          :label="$t(`label.open.${column}`)"
          align="center"
          show-overflow-tooltip
          :min-width="column == 'operate' ? '180px' : ''"
        >
          <template slot-scope="{ row }">
            <template v-if="column == 'operate'">
              <el-button
                type="warning"
                size="small"
                @click="operateBtn('edit_btn', row)"
                >{{ $t("label.open.role_edit") }}</el-button
              >
              <el-button
                type="danger"
                size="small"
                @click="operateBtn('delete_btn', row)"
                >{{ $t("label.open.delete_btn") }}</el-button
              >
            </template>
            <template v-else>
              {{ row[column] }}
            </template>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination
        background
        layout="sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="10"
        :total="total"
        popper-class="mySelectType"
        :current-page="page"
        @size-change="sizeChange"
        @current-change="currentChange"
      >
      </el-pagination>
    </div>
    <RoleEdit
      :show="showRoleEdit"
      :rowInfo.sync="opt_item"
      @toggleShow="toggleShowRoleEdit"
      @refush="getRoleList"
    ></RoleEdit>
  </div>
</template>

<script>
import {
  roleList,
  queryMemu,
  addRole,
  editRole,
  removeRole,
} from "@/api/index";
import RoleEdit from "./components/roleEdit.vue";
// import ViewDevice from "./component/viewDevice.vue";
// import viewDeviceDetail from "./component/viewDetail.vue";
// import AddThird from "./component/addThird.vue";
export default {
  data() {
    return {
      showRoleEdit: false,
      roleEditState: 1,
      opt_item: {},
      columns: ["index", "role_name", "role_describe", "operate"],
      tableData: [],
      total: 0,
      page: 1,
      pageSize: 10,
      company_name: "",
      userinfo: "",
      searchType: "sn",
      sn: "",
      ownership: "",
      fileList: [],
      // showAddThirdDevice: false,
      showAddThirdManu: false,
      showViewDevice: false,
      showAddThirdDevice: false,
      showDeviceDetail: false,
      showDis: false,
      choose: [],
      selectValue: [],
      tableHeight: 450,
    };
  },
  components: {
    RoleEdit,
  },
  watch: {
    "$store.getters.deviceInfo": {
      handler(val) {
        this.$nextTick(() => {
          this.$refs.tableData.doLayout();
        });
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.getRoleList();
    this.$nextTick(() => {
      // window.innerHeight 浏览器窗口的可见高度，下面的 220 是除了table最大高度的剩余空间。
      let height =
        window.innerHeight - this.$refs.tableData.$el.offsetHeight + 225;
      this.tableHeight = height;
    });
  },
  methods: {
    toSearch(){
      this.page = 1
      this.getRoleList()
    },
    toggleShowRoleEdit() {
      this.showRoleEdit = !this.showRoleEdit;
    },
    showPosition(position) {},
    showError(err) {
      console.log(err, "err");
    },
    delete_batch(row) {
      //  批量删除
      // if (!this.choose.length) {
      //   this.$message({
      //     type: "warning",
      //     message: "请先选择厂商",
      //   });
      //   return;
      // }
      this.$confirm("此操作将永久删除该角色, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = {
            role_id: row.id,
          };
          removeRole(params).then((res) => {
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: "删除用户成功！",
              });
            }
            this.getRoleList();
          });
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: "已取消删除",
          // });
          return
        });
    },
    //
    operateBtn(e, row) {
      this.opt_item = row;
      if (e == "delete_btn") {
        this.delete_batch(row);
      } else if (e == "add_btn") {
        this.add_role();
      } else if (e == "edit_btn") {
        this.edit_role();
      }
    },
    add_role() {
      this.roleEditState = 1; // 新增
      this.toggleShowRoleEdit();
    },
    edit_role() {
      this.roleEditState = 2; // 编辑

      this.toggleShowRoleEdit();
    },

    // 改变搜索条件搜索
    selectChange(e) {
      this.searchType = e;
    },
    getRoleList() {
      let param = {
        page_num: this.page,
        page_size: this.pageSize,
        // status: this.statusSelect,
        keyword: this.company_name,
      };
      // this.tableData = [];
      roleList(param).then((res) => {
        if (res.code == 200) {
          // console.log(res, "resssssss")
          this.total = res.data.total;
          this.tableData = res.data.infos.map((item, index) => {
            return {
              index: (this.page - 1) * this.pageSize + index + 1,
              role_name: item.name,
              id: item.role_id,
              org_name: item,
              role_describe: item.describe,
            };
          });
        }
      });
    },

    // 选择设备
    handleSelectionChange(e) {
      this.choose = e.map((_f) => {
        return _f.id;
      });
    },
    toggleShowAddThirdDevice() {
      this.showAddThirdDevice = !this.showAddThirdDevice;
    },
    closeDis() {
      this.showDis = false;
    },
    // 分页
    sizeChange(e) {
      this.page = 1
      this.pageSize = e;
      this.getRoleList();
    },
    // 页数
    currentChange(e) {
      this.page = e;
      this.getRoleList();
    },
    // 提交清除数据的选中状态
    searchTableData() {
      this.$refs.tableData.clearSelection(); //清除选中的数据
    },
    resetList() {
      this.page = 1;
      this.company_name = "";
      // this.userinfo = "";
      // this.total = 0;
      this.getRoleList();
      // this.pageSize = 10;
    },
  },
};
</script>

<style lang="scss" scoped>
.receiverList {
  padding: 20px;

  .query {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .input-width {
    max-width: 400px;
  }

  .operate-btn {
    display: flex;
  }

  .btn {
    min-width: 80px;
    height: 32px;
  }

  .table {
    margin-top: 10px;
    border-radius: 2px 2px 0px 0px;
    overflow: hidden;

    &::v-deep th.el-table__cell {
      background-color: $table_header;
      color: #fff;
    }

    &::v-deep td.el-table__cell {
      background: transparent !important;
    }

    &::v-deep .el-table__row--striped {
      background-color: #d2e9ce;
    }
  }

  .pagination {
    // display: flex;
    // align-items: center;
    // justify-content: flex-end;
    // margin-top: 12px;
    position: fixed;
    bottom: 0px;
    right: 20px;
    // width: 100%;
    display: flex;
    justify-content: flex-end;
    background-color: #ffffff;
    z-index: 999;
    padding-bottom: 10px;
  }

  ::v-deep {
    .el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #3b9167;
      color: #fff;
    }
    // .el-form-item {
    //   margin-bottom: 0px;
    // }

    .el-pagination.is-background .btn-next,
    .el-pagination.is-background .btn-prev,
    .el-pagination.is-background .el-pager li {
      background-color: #ffffff;
      border: 1px solid #e8e8e8;
    }

    .el-pagination.is-background .el-pager li:hover {
      color: #3b9167;
    }

    .el-pagination__sizes .el-input .el-input__inner:hover {
      border-color: #3b9167;
    }

    .el-select .el-input__inner:focus {
      border-color: #3b9167;
    }

    .el-select-dropdown__item.selected {
      color: #3b9167 !important;
    }

    .el-button--success.is-disabled {
      background-color: #c0c4cc;
      border-color: #c0c4cc;
    }

    // .el-pagination.is-background .el-pager li:not(.disabled):hover {
    // 	color: #3b9167;
    // }
  }
}
.mgl10 {
  margin-left: 10px;
}
</style>
<style lang="scss">
.mySelectType {
  .el-select-dropdown__item.selected {
    color: #3b9167 !important;
  }
}
</style>
